import { cn } from "@/lib/utils"

export function TextHint({ text, className }: { text: string; className?: string }) {
  return <p className={cn("mt-1 text-[12px] text-muted-foreground", className)}>{text}</p>
}
